import React from 'react'
import Main from '../components/main'
import Features from '../components/features'
import Allmodules from '../components/allmodules'


function Home() {
    return (
        <div>
            <Main />
            <Features />
            <Allmodules />
        </div>
    )
}

export default Home
